
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"101","height":"101","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.834 16.833h67.333c4.63 0 8.417 3.788 8.417 8.417v50.5c0 4.629-3.788 8.416-8.417 8.416H16.834c-4.63 0-8.417-3.787-8.417-8.416v-50.5c0-4.63 3.787-8.417 8.417-8.417z","stroke":"#FFB0E2","stroke-width":"5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M92.584 25.25L50.5 54.708 8.417 25.25","stroke":"#FFB0E2","stroke-width":"5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    